import React from 'react';
import { UserEditTemplate } from 'themes/modules/user/pages';
import { setCurrentView } from 'core/utils';
import { UserEditViewStore } from 'modules/user/stores';

@setCurrentView((rootStore, componentProps) => new UserEditViewStore(rootStore, componentProps), 'userEditViewStore')
class UserEdit extends React.Component {
	render() {
		return <UserEditTemplate {...this.props} />;
	}
}

export default UserEdit;



// WEBPACK FOOTER //
// ./src/modules/user/pages/UserEdit.jsx